module.exports = "<popover\r\n\t#popover\r\n\t[hasChanges]=\"hasChanges\"\r\n\t[disabled]=\"disabled\"\r\n\t(onShow)=\"onShow()\"\r\n\t(onSave)=\"onSave($event)\"\r\n\t(onCancel)=\"onCancel()\"\r\n\t[name]=\"name\"\r\n\t[placement]=\"placement\">\r\n\t\r\n\t{{originalValue}}\r\n\t\r\n\t<textarea edit\r\n\t\t\t  #focus \r\n\t\t\t  class=\"form-control\"\r\n\t\t\t  type=\"text\" \r\n\t\t\t  style=\"height: 85px; width: 220px;\"\r\n\t\t\t  [(ngModel)]=\"dirtyValue\"\r\n\t\t\t(keyup.Escape)=\"onCancel()\"></textarea>\r\n</popover>";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/editable-popover/popover-textarea.template.html
// module id = 419
// module chunks = 10